import { addHours } from 'date-fns';

import { HealthMetricsHistory } from 'features/Health/containers/MonetisationHealthChartContainer/types/healthMetrics';
import { START_DATE } from 'mocks/server/utils/constants';

export const deliveryHistory: HealthMetricsHistory[] = [
  {
    date: START_DATE.getTime(),
    value: 90,
  },
  {
    date: addHours(START_DATE, 1).getTime(),
    value: 93,
  },
  {
    date: addHours(START_DATE, 2).getTime(),
    value: 88,
  },
  {
    date: addHours(START_DATE, 3).getTime(),
    value: 87,
  },
  {
    date: addHours(START_DATE, 4).getTime(),
    value: 91,
  },
  {
    date: addHours(START_DATE, 5).getTime(),
    value: 91,
  },
  {
    date: addHours(START_DATE, 6).getTime(),
    value: 88,
  },
  {
    date: addHours(START_DATE, 7).getTime(),
    value: 80,
  },
  {
    date: addHours(START_DATE, 8).getTime(),
    value: 90,
  },
  {
    date: addHours(START_DATE, 9).getTime(),
    value: 100,
  },
  {
    date: addHours(START_DATE, 10).getTime(),
    value: 99,
  },
  {
    date: addHours(START_DATE, 11).getTime(),
    value: 75,
  },
  {
    date: addHours(START_DATE, 12).getTime(),
    value: 83,
  },
  {
    date: addHours(START_DATE, 13).getTime(),
    value: 89,
  },
  {
    date: addHours(START_DATE, 14).getTime(),
    value: 90,
  },
  {
    date: addHours(START_DATE, 15).getTime(),
    value: 87,
  },
  {
    date: addHours(START_DATE, 16).getTime(),
    value: 80,
  },
  {
    date: addHours(START_DATE, 17).getTime(),
    value: 89,
  },
  {
    date: addHours(START_DATE, 18).getTime(),
    value: 79,
  },
  {
    date: addHours(START_DATE, 19).getTime(),
    value: 76,
  },
  {
    date: addHours(START_DATE, 20).getTime(),
    value: 80,
  },
  {
    date: addHours(START_DATE, 21).getTime(),
    value: 81,
  },
  {
    date: addHours(START_DATE, 22).getTime(),
    value: 85,
  },
];
